export default[
    {
        path: '/desligamento/tabelapreco/cadastro/:trabalhador_id',
        name: 'cadastro da tabela de preço do desligamento', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/desligamento/tabelapreco/lista/:trabalhador_id',
        name: 'lista da tabela de preço do desligamento', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/desligamento/tabelapreco/editar/:id',
        name: 'editar da tabela de preço do desligamento', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]